
import { tr } from "date-fns/locale";
import React, { useState, useMemo, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { CalendarSelector } from "views/GlAnalytics/DayWeekMonthPicker";
import api from "../../api"




export default function FieldDeviceGraphs() {
  // const [activeTab, setActiveTab] = useState("all");
  // const [timeTab, setTimeTab] = useState("week");

  // const data = areaChartData;
  const [areaChartData, setAreaChartData] = useState([]);
  const seriesKeys = areaChartData?.map(item => item?.label);

  const btnBase = {
    padding: "4px 12px",
    borderRadius: 14,
    border: "1px solid #e0e0e0",
    background: "#f5f5f5",
    color: "#555",
    fontSize: 11,
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
    fontFamily: "'DM Sans', sans-serif",
    transition: "all 0.15s",
  };
  // const btnActive = { ...btnBase, background: "#0123b4", color: "#fff", borderColor: "#0123b4" };
  const [dateMode, setDateMode] = useState("day");

  console.log(areaChartData, "areaChartData");

  const [selectedDate, setSelectedDate] = useState(() => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toISOString().split("T")[0];
  });
  console.log(selectedDate, "selectedDate");

  const parseDateInput = (input) => {
    if (!input) return input;
    if (typeof input === "object" && input.startDate) {
      const p = input.startDate.split("/");
      return `${p[2]}-${p[1]}-${p[0]}`;
    }
    if (input instanceof Date) return input.toISOString().split("T")[0];
    if (typeof input === "string" && input.includes("/")) {
      const p = input.split("/");
      return `${p[2]}-${p[1]}-${p[0]}`;
    }
    return input;
  };

  const handleDateSelect = (date) => { setDateMode("day"); setSelectedDate(parseDateInput(date)); };
  const handleWeekSelect = (week) => { setDateMode("week"); setSelectedDate(parseDateInput(week)); };
  const handleMonthSelect = (month) => { setDateMode("month"); setSelectedDate(parseDateInput(month)); };
  const handleYearSelect = (year) => { setDateMode("year"); setSelectedDate(parseDateInput(year)); };


  useEffect(() => {
    if (selectedDate) {
      fetchEnergyData();
    }
  }, [selectedDate, dateMode]);

  const toLocalDateStr = (d) => {
    const yy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yy}-${mm}-${dd}`;
  };

  const fetchEnergyData = async () => {
    try {
      const { startDate, endDate, timeRange } = getDateRange();
      const response = await api.dashboard.getEnergyConsumptionData(timeRange == "daily" ? "hourly" : timeRange, startDate, endDate);
      if (response?.success && Array.isArray(response.data) && response.data.length > 0) {
        setAreaChartData(response.data);
        // setAreaChartLabels(response.data.map((item) => item.label));
        // debugger
      }
      else {
        setAreaChartData([]);
      }
    } catch (err) {
      setAreaChartData([]);
      console.error("Energy data error:", err);
    } finally {
      // setLoading(false);
    }
  };

  const getDateRange = () => {
    let startDate, endDate, timeRange;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const clampToToday = (date) => {
      return date > today ? today : date;
    };

    if (dateMode === "day") {
      const selected = new Date(selectedDate + "T00:00:00");

      startDate = selectedDate;
      endDate = toLocalDateStr(clampToToday(selected));
      timeRange = "daily";

    } else if (dateMode === "week") {
      const start = new Date(selectedDate + "T00:00:00");
      const end = new Date(start);
      end.setDate(start.getDate() + 6);

      startDate = selectedDate;
      endDate = toLocalDateStr(clampToToday(end));
      timeRange = "weekly";

    } else if (dateMode === "month") {
      const start = new Date(selectedDate + "T00:00:00");
      const end = new Date(start.getFullYear(), start.getMonth() + 1, 0);

      startDate = selectedDate;
      endDate = toLocalDateStr(clampToToday(end));
      timeRange = "monthly";

    } else if (dateMode === "year") {
      const year =
        typeof selectedDate === "string"
          ? new Date(selectedDate).getFullYear()
          : selectedDate;

      const start = new Date(year, 0, 1);
      const end = new Date(year, 11, 31);

      startDate = toLocalDateStr(start);
      endDate = toLocalDateStr(clampToToday(end));
      timeRange = "yearly";

    } else if (dateMode === "custom" && Array.isArray(selectedDate)) {
      const start = new Date(selectedDate[0] + "T00:00:00");
      const end = new Date(selectedDate[1] + "T00:00:00");

      const finalEnd = clampToToday(end);

      startDate = selectedDate[0];
      endDate = toLocalDateStr(finalEnd);

      const diff = Math.ceil(
        (finalEnd - start) / 86400000
      );

      timeRange =
        diff === 0
          ? "daily"
          : diff <= 7
            ? "weekly"
            : diff <= 31
              ? "monthly"
              : diff <= 366
                ? "yearly"
                : "custom";
    }

    return { startDate, endDate, timeRange };
  };
  const { startDate, endDate, timeRange } = getDateRange();
  const displayDate = (() => {
    if (dateMode === "day") {
      return startDate;
    }

    if (dateMode === "week") {
      return `${startDate} - ${endDate}`;
    }

    if (dateMode === "month") {
      return `${startDate} - ${endDate}`;
    }

    if (dateMode === "year") {
      return new Date(startDate).getFullYear();
    }

    return startDate;
  })();
  return (
    <div style={{
      width: "100%",
      backgroundColor: "#fff",
      borderRadius: 12,
      border: "1.5px solid #e0e0e0",
      padding: "2px",
      boxSizing: "border-box",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      {/* Top controls row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 8,
          marginBottom: 8,
        }}
      >
        <h3
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            padding: "4px 8px",
            background: "#f1f5f9",
            borderRadius: "6px",
            fontSize: "11px",
            fontWeight: 500,   // reduced overall weight
            color: "#334155",
            margin: 0,
            boxShadow: "none", // removed heavy shadow
          }}
        >
          <span
            style={{
              color: "#64748b",
              textTransform: "capitalize",
              fontWeight: 500,
            }}
          >
            Selected {dateMode}:
          </span>

          <span
            style={{
              background: "#ffffff",
              padding: "1px 5px",
              borderRadius: "4px",
              fontWeight: 600,  // slightly bold but not heavy
              fontSize: "11px",
              color: "#0f172a",
            }}
          >
            {displayDate}
          </span>
        </h3>

        <CalendarSelector
          defaultMode="day"
          onDateSelect={handleDateSelect}
          onWeekSelect={handleWeekSelect}
          onMonthSelect={handleMonthSelect}
          onYearSelect={handleYearSelect}
          showSelection={false}
        />
      </div>

      {/* Chart card */}
      <div style={{
        background: "#fafafa",
        borderRadius: 10,
        border: "1px solid #ebebeb",
        // padding: "12px 16px 8px",
      }}>
        {/* <CustomLegend series={seriesKeys} /> */}
        <div style={{ height: 145 }}>
          {/* <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} barCategoryGap="30%" barGap={3} margin={{ top: 4, right: 8, left: -10, bottom: 0 }}>
              <CartesianGrid vertical={false} stroke="#f0f0f0" />
              <XAxis
                dataKey="label"
                tick={{ fontSize: 10, fill: "#9ca3af", fontFamily: "'DM Sans', sans-serif" }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                tick={{ fontSize: 10, fill: "#9ca3af", fontFamily: "'DM Sans', sans-serif" }}
                axisLine={false}
                tickLine={false}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(0,0,0,0.04)" }} />
              {data.map((key) => (
                <Bar key={key?.label} dataKey={key?.value} fill={SERIES_COLORS[key?.label]} radius={[3, 3, 0, 0]} />
              ))}
            </BarChart>
          </ResponsiveContainer> */}
          {areaChartData.length > 0 ? <ResponsiveContainer width="100%" height="100%">
            <BarChart data={areaChartData}>
              <CartesianGrid strokeDasharray="3 3" />

              <XAxis dataKey="label" />
              <YAxis />
              <Tooltip />

              <Bar
                dataKey="value"
                fill="#60a5fa"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
            : <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
              <p style={{ color: "#9ca3af", fontSize: 12, fontStyle: "italic" }}>No data available for the selected date range.</p>
            </div>
          }
        </div>
      </div>
    </div>
  );
}